import React, { useState } from 'react';
import * as cls from './models-and-compatibility.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';

const single = [
  <>Form factor: Non-invasive clamp-on sensor; DIN-rail gateway</>,
  <>
    Connectivity: <strong>IEEE 802.11 b/g/n 2.4 GHz</strong> (optional GSM for
    pilots)
  </>,
  <>Power: Mains-powered gateway</>,
  <>
    Operating voltage: <strong>85–250 V AC</strong> · Frequency:{' '}
    <strong>50–60 Hz</strong>
  </>,
  <>
    Power consumption (typical): <strong>~1 W</strong>
  </>,
  <>
    Supported CT: <strong>1 × 30 A / 50 A</strong> · Max measured power:{' '}
    <strong>7.5 / 15 / 25 kW</strong>
  </>,
  <>
    Case: <strong>83 × 56 × 7 mm</strong> · Mounting:{' '}
    <strong>Top-hat rail EN 50022 — 35 × 15</strong>
  </>,
];

const three = [
  <>Form factor: Non-invasive clamp-on sensor; DIN-rail gateway</>,
  <>
    Connectivity: <strong>IEEE 802.11 b/g/n 2.4 GHz</strong> (optional GSM for
    pilots)
  </>,
  <>Power: Mains-powered gateway</>,
  <>
    Operating voltage: <strong>85–250 V AC</strong> · Frequency:{' '}
    <strong>50–60 Hz</strong>
  </>,
  <>
    Power consumption (typical): <strong>~1 W</strong>
  </>,
  <>
    Supported CT: <strong>3 × 100 A / phase</strong>
  </>,
  <>
    Case: <strong>87 × 56 × 16 mm</strong> · Mounting:{' '}
    <strong>Top-hat rail EN 50022 — 35 × 15</strong>
  </>,
];

export const ModelsAndCompatibility = () => {
  const [active, setActive] = useState(0);

  return (
    <Section backgroundContrast classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        Models & Compatibility
      </Typography>

      <div className={cls.buttons}>
        <button
          className={active === 0 ? cls['button--active'] : ''}
          onClick={() => setActive(0)}
        >
          Single-Phase (Wi-Fi)
        </button>
        <button
          className={active === 1 ? cls['button--active'] : ''}
          onClick={() => setActive(1)}
        >
          Three-Phase (Wi-Fi)
        </button>
      </div>

      <div className={cls.wrapper}>
        <div className={active === 0 ? cls['wrapper--active'] : ''}>
          <div className={cls.imgWrapper}>
            <img
              alt="Single-phase Wi-Fi sensor with DIN-rail gateway."
              src={`${IMG_PATH}/our-technology/hardware/sensor-single-phase.png`}
            />
          </div>
          <ul className={cls.list}>
            {single.map((item, index) => (
              <li key={index}>
                <Typography>
                  <span>{item}</span>
                </Typography>
              </li>
            ))}
          </ul>
        </div>
        <div className={active === 1 ? cls['wrapper--active'] : ''}>
          <div className={cls.imgWrapper}>
            <img
              alt="Three-phase Wi-Fi sensor with DIN-rail gateway and three CTs."
              src={`${IMG_PATH}/our-technology/hardware/sensor-three-phase.png`}
            />
          </div>
          <ul className={cls.list}>
            {three.map((item, index) => (
              <li key={index}>
                <Typography>
                  <span>{item}</span>
                </Typography>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
};
